export enum SupportRequestType {
  Technical = 'Technical',
  Payment = 'Payment',
  MissingSomething = 'MissingSomething',
  SurveyBuilder = 'SurveyBuilder',
  Invoice = 'Invoice',
  MoreInfo = 'MoreInfo',
  Output = 'Output',
  Other = 'Other',
}

export default class {
  public constructor(
    readonly supportType: SupportRequestType,
    readonly firstName: string,
    readonly lastName: string,
    readonly email: string,
    readonly description: string
  ) {}
}
